"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDays = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormGroup_1 = __importDefault(require("@material-ui/core/FormGroup"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var styles_1 = require("@material-ui/core/styles");
var lodash_1 = require("lodash");
var strings_1 = __importDefault(require("../strings"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    formLabel: {
        fontSize: 16,
        color: function (props) { return (!!props.errorText
            ? theme.palette.error.main
            : theme.palette.text.primary); },
    },
}); });
;
var FormControlWrapper = function (props) {
    var classes = useStyles(props);
    return (react_1.default.createElement(FormControl_1.default, { error: !!props.errorText },
        props.label && react_1.default.createElement("label", { className: classes.formLabel }, props.label),
        !!props.errorText &&
            react_1.default.createElement(FormHelperText_1.default, null, props.errorText),
        props.children));
};
var SelectDays = function (props) {
    var _a = react_1.default.useState(props.initialDays || []), days = _a[0], setDays = _a[1];
    var formControlWrapperProps = {
        label: props.label,
        errorText: props.errorText,
    };
    react_1.default.useEffect(function () {
        if (props.initialDays && !lodash_1.isEqual(props.initialDays, days)) {
            setDays(props.initialDays);
        }
    }, [props.initialDays]);
    var onClickDay = function (day) {
        var newDays = Object.assign([], days);
        var idx = newDays.indexOf(day);
        if (idx > -1) {
            newDays.splice(idx, 1);
        }
        else {
            newDays.push(day);
        }
        setDays(newDays);
        if (props.onChange) {
            props.onChange(newDays);
        }
    };
    var buttons = props.buttonsContent
        ? props.buttonsContent
        : strings_1.default.days.slice(0, props.includeWeekends ? 7 : 5);
    var renderButton = function (day, idx, grid) {
        var button = (react_1.default.createElement(Button_1.default, { key: "button-" + day, id: "button-" + day, style: props.isInactive
                ? grid
                    ? { color: "grey" }
                    : { color: "grey", marginRight: "4px" }
                : grid
                    ? undefined
                    : { marginRight: "4px" }, fullWidth: true, variant: props.isInactive || days.indexOf(idx) > -1 ? "contained" : "outlined", disabled: props.isInactive ||
                (props.availableDays && props.availableDays.indexOf(idx) === -1), color: "primary", onClick: props.readOnly ? undefined : function () { return onClickDay(idx); } }, day));
        var checkbox = (react_1.default.createElement(FormGroup_1.default, null,
            react_1.default.createElement(FormControlLabel_1.default, { key: "checkbox-" + day, id: "checkbox-" + day, control: react_1.default.createElement(Checkbox_1.default, { color: "primary", checked: days.indexOf(idx) > -1, disabled: props.isInactive ||
                        (props.availableDays && props.availableDays.indexOf(idx) === -1), onClick: props.readOnly ? undefined : function () { return onClickDay(idx); } }), label: day })));
        if (grid) {
            return (react_1.default.createElement(Grid_1.default, { key: "day-" + day, item: true, xs: props.singleRow ? (buttons < 7 ? 2 : 1) : 4 }, props.useCheckboxes ? checkbox : button));
        }
        return props.useCheckboxes ? checkbox : button;
    };
    if (props.singleRow) {
        return (react_1.default.createElement(FormControlWrapper, __assign({}, formControlWrapperProps),
            react_1.default.createElement("div", { style: { display: "flex", justifyContent: "flex-start", flexWrap: "wrap" } }, buttons.map(function (day, idx) {
                return renderButton(day, idx, false);
            }))));
    }
    var firstButtonInPair = true;
    return (react_1.default.createElement(FormControlWrapper, __assign({}, formControlWrapperProps),
        react_1.default.createElement(Grid_1.default, { container: true, className: "mt-1 ml-1 mr-1", spacing: 1 }, buttons.map(function (day, idx) {
            if (buttons.length % 3 === 0 || buttons.length < 3) {
                return renderButton(day, idx, true);
            }
            else if (idx < 3 * Math.floor((buttons.length - 2) / 3)) {
                return renderButton(day, idx, true);
            }
            else if (firstButtonInPair) {
                firstButtonInPair = false;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Grid_1.default, { key: "space-before", item: true, xs: 2 }),
                    renderButton(day, idx, true)));
            }
            else {
                firstButtonInPair = true;
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    renderButton(day, idx, true),
                    react_1.default.createElement(Grid_1.default, { key: "space-after", item: true, xs: 2 })));
            }
        }))));
};
exports.SelectDays = SelectDays;
